export type NoticeBannerTranslations = {
  updatedAt: (when: string) => string;
};

/** Partner app only. Customer notices do not name a person. */
export type NoticeActorTranslations = NoticeBannerTranslations & {
  createdAt: (when: string) => string;
  createdBy: (when: string, name: string) => string;
  updatedBy: (when: string, name: string) => string;
};

export const noticeBannerTranslations: NoticeActorTranslations = {
  updatedAt: (when) => `Updated ${when}`,
  createdAt: (when) => `Created ${when}`,
  createdBy: (when, name) => `Created ${when} by ${name}`,
  updatedBy: (when, name) => `Updated ${when} by ${name}`
};
